import { API } from '../config/axiosConfig';
import endpoints from '../endpoints/endpoints';

export const orderTrackingModule = {
  getWaybill: async (tracking_reference) => {
    try {
      const response = await API.get(
        `${endpoints.getWaybill}?tracking_reference=${tracking_reference}`
      );
      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to get waybill',
        error: error.response?.data || error,
      };
    }
  },

  trackingOrder: async (payload) => {
    try {
      const response = await API.get(endpoints.trackingOrder, { params: payload });
      return {
        success: true,
        data: response.data,
        message: response.data.message || 'order tracking successfully',
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to track order',
        error: error.response?.data || error,
      };
    }
  },

  createLabel: async (payload) => {
    try {
      const response = await API.post(endpoints.createLabel, payload);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Label created successfully',
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to create label',
        error: error.response?.data || error,
      };
    }
  },

  submitRating: async (payload) => {
    try {
      const response = await API.post(endpoints.submitRating, payload);
      return {
        success: true,
        data: response.data,
        message: response.data?.message || 'Rating submitted successfully',
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to submit rating',
        error: error.response?.data || error,
      };
    }
  },

  // Buyer-scoped order status poll (Task 10): GET /api/orders/{id}/status/.
  // Route prefix confirmed against apps/orders/urls.py (mounted at
  // "api/orders/" in vaultsa_kanban/urls.py) rather than assumed.
  getOrderStatus: async (orderId) => {
    try {
      const response = await API.get(`/api/orders/${orderId}/status/`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to get order status',
        error: error.response?.data || error,
      };
    }
  },

  // Redirect-triggered settlement fallback: asks the backend to verify this
  // order against Yoco directly, so a broken webhook pipe can't strand a
  // captured payment on the success screen.
  verifyPayment: async (orderId) => {
    try {
      const response = await API.post(`/api/orders/${orderId}/verify-payment/`);
      return response.data;
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to verify payment',
        error: error.response?.data || error,
      };
    }
  },

  // Admin-only (Task 6): POST /api/orders/{id}/resubmit-shipment/. Backend
  // (Task 4) 400s unless the shipment's submission_status is
  // no-rates/failed-indefinitely, so the frontend only shows the button in
  // that state. Returns { success, message, data } straight through.
  resubmitShipment: async (orderId) => {
    try {
      const res = await API.post(`/api/orders/${orderId}/resubmit-shipment/`);
      return res.data;
    } catch (error) {
      return { success: false, message: error.response?.data?.message || 'Re-submit failed' };
    }
  },
};
